/**
 * Customer wording for a failed **registration** item's `error_code` (docs/api-types/domain-orders.md,
 * Show order → item `error_code`). Only the two codes the customer can act on are mapped; any other
 * code returns `null` so the page keeps its generic refund copy.
 *
 * A waived (staff) order collected no money, so its wording never promises a refund.
 */
export function registrationFailureMessage(errorCode: string | null, waived: boolean): string | null {
  switch (errorCode) {
    case 'registrar_setup_failed':
      return waived
        ? 'The registry did not complete this registration.'
        : 'The registry did not complete this registration — you will be refunded.';
    case 'conflict':
      return waived
        ? 'This domain is already registered or being registered — nothing was charged for it at the registry.'
        : 'This domain is already registered or being registered — nothing was charged for it at the registry; you will be refunded.';
    default:
      return null;
  }
}
